import { ErrorMessage } from 'formik';
import React, { Component } from 'react';
import CurrencyInput from 'components/Input/currencyInput.component';
import Input from '../../../components/Input/input.component';
import WidgetModalForm, { ModalFormContext } from '../../../components/Modal/modalForm.component';
import Required from '../../../components/Required/required.component';
import SelectMulti from '../../../components/SelectMulti/selectmulti.component';
import centralDoacaoService from '../../../services/centralDoacaoService';
import { CadastroDoacaoValidationSchema } from './modal.validate';

export default class CadastrarModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cadastro: {
				nome: '',
				tipoItemDoacao: {
					codigo: '',
				},
				unidadeMedidaItemDoacao: {
					codigo: '',
					nome: '',
				},
				volume: '',
			},
			tipoItens: [],
			unidadesMedida: [],
		};
	}

	async componentDidMount() {
		const responseTipoItens = await centralDoacaoService.findAllTipoItemDoacao();
		const responseUnidadesMedida = await centralDoacaoService.findAllUnidadeMedida();
		this.setState({
			tipoItens: [...responseTipoItens.data.dados],
		});
		this.setState({
			unidadesMedida: [...responseUnidadesMedida.data.dados],
		});
	}

	handleSetUnidadeMedida = (codigo) => {
		const { unidadesMedida } = this.state;
		const unidadeMedida = unidadesMedida.filter(item => item.codigo === codigo)[0];
		return unidadeMedida ? unidadeMedida.nome : null;
	};

	handleShowEspecificacaoUnidadeMedida = (codigo) => {
		if (!codigo || codigo === '' || codigo === 'UNIDADE' || codigo === 'PARES') {
			return false;
		}
		return true;
	};

	render() {
		const {
			isOpenCadastrar,
			handleCloseCadastrar,
			handleSalvarCadastrar,
		} = this.props;

		const { unidadesMedida, tipoItens } = this.state;

		return (
			<WidgetModalForm
				textCancelar='Cancelar'
				textConfirmar='Cadastrar'
				initialValues={this.state.cadastro}
				validationSchema={CadastroDoacaoValidationSchema}
				title='Cadastrar item'
				confirmar={handleSalvarCadastrar}
				isOpen={isOpenCadastrar}
				cancelar={handleCloseCadastrar}
				modalConfirmarFechar
				modalConfirmarCancelar
				modalConfirmarCancelarTitulo='Atenção!'
				modalConfirmarCancelarCorpo='Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos.'
				iconCancelar='fas fa-times'
				iconConfirmar='fas fa-save'
			>
				<ModalFormContext.Consumer>
					{({ values, handleChange, setFieldValue }) => (
						<div>
							<div className='row'>
								<div className='col-md-12 form-group'>
									<label>
										Nome do item: <Required />
									</label>
									<Input
										maxLength='255'
										name='nome'
										bsSize='sm'
										onChange={handleChange}
										value={values.nome}
									/>
									<ErrorMessage
										name='nome'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>
							</div>
							<label>
								Tipo de item: <Required />
							</label>
							<div className='row'>
								{tipoItens.map((item, index) => (
									<div key={index} className='col-md-3 mb-4'>
										<div className='form-check form-check-inline'>
											<Input
												id={`radio_${index}`}
												name='tipoItemDoacao.codigo'
												type='radio'
												bsSize='sm'
												className='form-check-input'
												onChange={() => setFieldValue(
													'tipoItemDoacao.codigo',
													`${item.codigo}`,
												)
												}
											/>
											<label
												htmlFor={`radio_${index}`}
												className='form-check-label pointer-text'
											>
												{item.nome}
											</label>
										</div>
									</div>
								))}
								<ErrorMessage
									name='tipoItemDoacao.codigo'
									render={msg => (
										<span className='ml-3 text-danger'>
											{msg}
										</span>
									)}
								/>
							</div>

							<div className='row  mt-2 '>
								<div className='col-md-6 form-group'>
									<label>
										Unidade de medida: <Required />
									</label>
									<SelectMulti
										isClearable={false}
										isMulti={false}
										name='unidadeMedidaItemDoacao'
										uniqueKey='codigo'
										label='nome'
										value={values ? values.unidadeMedidaItemDoacao : ''}
										onChange={(e) => {
											handleChange(e);
											setFieldValue('unidadeMedidaItemDoacao', e.object);
											if (!e.value || e.value === '' || e.value === 'UNIDADE' || e.value === 'PARES') {
												setFieldValue('volume', '');
											}
										}}
										options={unidadesMedida}
									/>
									<ErrorMessage
										name='unidadeMedidaItemDoacao.codigo'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>
								{this.handleShowEspecificacaoUnidadeMedida(values.unidadeMedidaItemDoacao.codigo) && (
									<div className='col-md-6  form-group'>
										<label>Quantos {this.handleSetUnidadeMedida(values.unidadeMedidaItemDoacao.codigo)}:</label>
										<CurrencyInput
											value={values.volume !== 0 && values.volume !== '' ? values.volume : null}
											handleChange={(e) => {
												setFieldValue('volume', e.target.value);
											}}
										/>
										<ErrorMessage
											name='volume'
											render={msg => (
												<span className='text-danger'>
													{msg}
												</span>
											)}
										/>
									</div>
								)}
							</div>
						</div>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
